export const SET_SEARCH_TEXT = "SET_SEARCH_TEXT";
